import { IOffer } from "@nju/data-access-portal-offers";
import { sortByOfferPrice } from "./sortByOfferPrice";

interface IFilterRoamingPackagesProps {
  offers: IOffer[];
  id: "DATA_PACKAGE" | "VOICE_PACKAGE";
  roamingZone: string | null | undefined;
}

export function filterRoamingPackages({
  offers,
  id,
  roamingZone,
}: IFilterRoamingPackagesProps) {
  return offers
    .filter((offer) => {
      return (
        offer.visibility &&
        offer.category === "ROAMING" &&
        offer.productSpecificationType === "PRODUCT" &&
        offer.productSpecificationId === id &&
        offer.zone === roamingZone
      );
    })
    .sort(sortByOfferPrice);
}
